/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { fetchGraphQl } from '@/quote-management/api';
import { StoreConfigModel } from '@/quote-management/data/models';
import { transformStoreConfig } from '@/quote-management/data/transforms';
import { STORE_CONFIG_QUERY } from './graphql/StoreConfigQuery';

export const getStoreConfig = async (): Promise<StoreConfigModel> => {
  return fetchGraphQl(STORE_CONFIG_QUERY, {
    method: 'GET',
    cache: 'force-cache',
  }).then(({ errors, data }) => {
    if (errors) {
      const errorMessage = errors.map((e: any) => e.message).join(', ');
      throw new Error(`Failed to get store config: ${errorMessage}`);
    }

    return transformStoreConfig(data.storeConfig);
  });
};
